import { useMemo } from 'react';
import { useAuth } from '../../utils/Auth';
import QrReturnByCategory from '../../components/QrComponents/QrReturnByCategory';
import { useFilteredAndSortedQRs } from '../../utils/hooks/useFilteredAndSortedQrs';
import SearchFilterSort from '../../components/QrComponents/SearchFilterSort';
import { useLayout } from '../../utils/hooks/useLayout';
import { AnimatePresence, motion } from 'motion/react';
import { variants, transition } from './variants';
import AddBtn from './AddBtn';
import LayoutBtns from '../../components/QrComponents/LayoutBtns';
import styles from './QrCodes.module.css';

export default function QrCodes() {
    // ----- STATE INITIALIZATION -----
    const { currentUser, liquidQRs } = useAuth();
    const linkedQRs = useMemo(() => liquidQRs?.filter(qr => qr?.data?.linked_qr), [liquidQRs]);
    const liquidQRLength = useMemo(() => liquidQRs?.filter(obj => !obj.id.startsWith('-')).length, [liquidQRs]);

    // layout function
    const [ layout, setLayout ] = useLayout(`${currentUser?.uid}_layout`, 'grid');
    const [ filters, setFilters, searchReturnArr ] = useFilteredAndSortedQRs(liquidQRs);
    // ----- END STATE INITIALIZATION -----
    // ----------------------------------------------  

    const renderQrContent = () => {
        if (!liquidQRs || liquidQRs.length === 0) {
            return (
                <div className={styles.noQRs}>
                    <p>You don't have any QRs yet.</p>
                    <p>Click the plus sign (top left) to create a QR!</p>
                </div>
            );
        };

        return (
            <>
            <SearchFilterSort filters={filters} setFilters={setFilters} />
            {searchReturnArr?.length > 0 ? (
                <QrReturnByCategory 
                    searchReturnArr={searchReturnArr} 
                    layout={layout} 
                    setFilters={setFilters} 
                    searchValue={filters?.searchValue} 
                    linkedQRs={linkedQRs} 
                />
            ) : (
                <div className={styles.noReturnValue}>
                    {filters?.searchValue?.includes('category value') ? filters.searchValue : `No QRs found.`}
                </div>
            )}
            </>
        );
    };

    return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                <AnimatePresence mode='wait'>
                    <motion.div 
                        className={styles.qrs}
                        transition={transition}
                        variants={variants}
                        initial='initial'
                        animate='animate'
                        exit='initial'
                    >
                        <AddBtn activeQRs={liquidQRs} liquidQRLength={liquidQRLength} />
                        {(searchReturnArr?.length > 0 || liquidQRs?.length > 0) && <LayoutBtns layout={layout} setLayout={setLayout} />}
                        {renderQrContent()}
                    </motion.div>
                </AnimatePresence>
            </div>
        </div>
    );
};